<template>
  <!-- <div>
    <card>
      <div slot="header">
        <h4 class="card-title">所有商店</h4>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column min-width="50" type="index" ></el-table-column>
            <el-table-column min-width="150" prop="name"
                             label="商店名稱" sortable>
            </el-table-column>
            <el-table-column min-width="200" prop="info"
                             label="info">
            </el-table-column>
            <el-table-column min-width="150"
                             header-align="right"
                             label="Actions">
              <div slot-scope="{row}" class="text-right table-actions">
                <el-tooltip content="Info"
                            :open-delay="300"
                            placement="top">
                  <n-button type="info" size="sm" icon>
                    <i class="now-ui-icons users_single-02" @click="clickInfo(row)"></i>
                  </n-button>
                </el-tooltip>


                <el-tooltip content="Settings"
                            :open-delay="300"
                            placement="top">
                  <n-button type="success" size="sm" icon>
                    <i class="now-ui-icons ui-2_settings-90" @click="clickEdit(row)"></i>
                  </n-button>
                </el-tooltip>

                <el-tooltip content="QR code"
                            :open-delay="300"
                            placement="top">
                  <n-button type="warn" size="sm" icon>
                    <font-awesome-icon icon="qrcode" @click="clickQR(row)"/>
                  </n-button>
                </el-tooltip>

                <el-tooltip content="Delete"
                            :open-delay="300"
                            placement="top">
                  <n-button type="danger" size="sm" icon>
                    <i class="now-ui-icons ui-1_simple-remove" @click="clickDel"></i>
                  </n-button>
                </el-tooltip>

              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </card>
  </div>-->
  <div class="container">
    <div style="margin: 10px 10px 10px 10px;">
      <el-row>
        <!-- <el-col :span="18">
          <el-button type="warning" @click="createShop">新增商店</el-button>
        </el-col>-->
        <el-col :span="6">
          <el-input placeholder="Search" v-model="filters[0].value"></el-input>
        </el-col>
      </el-row>
    </div>

    <data-tables
      :data="tableData"
      :pagination-props="{ pageSizes: [15, 25, 50] }"
      :filters="filters"
      :table-props="tableProps"
    >
      <el-table-column label="商店ID" prop="id" sortable="custom" min-width="20px">
        <template slot-scope="scope">{{scope.row.accountId || scope.row.id}}</template>
      </el-table-column>
      <el-table-column label="商店名稱" prop="name" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.name}}</template>
      </el-table-column>
      <el-table-column label="商店統編" prop="invoice" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.invoice}}</template>
      </el-table-column>
      <!-- <el-table-column label="所屬SI" min-width="30px">
        <template slot-scope="scope">
          <el-select
            class="select-primary"
            size="large"
            placeholder="Single Select"
            v-model="scope.row.siAccountName"
            @change="selectChange(scope.row)"
          >
            <el-option
              v-for="option in siAccounts"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>-->

      <el-table-column label="Actions" min-width="20px">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">商店參數</div>
            <n-button type="info" size="sm" icon @click.native="clickInfo(scope.row)">
              <i class="now-ui-icons users_single-02"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">修改商店設定</div>
            <n-button type="success" size="sm" icon @click.native="clickEdit(scope.row)">
              <i class="now-ui-icons ui-2_settings-90"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">桌號QRCode管理</div>
            <n-button type="warn" size="sm" icon @click.native="clickQR(scope.row)">
              <font-awesome-icon icon="qrcode" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">營業公休設定</div>
            <n-button
              type="default"
              style="background:#A25DDC;"
              size="sm"
              icon
              @click.native="openingSetting(scope.row)"
            >
              <i class="now-ui-icons ui-1_calendar-60"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">發送商店資訊郵件</div>
            <n-button type="warning" size="sm" icon @click.native="sendEmail(scope.row)">
              <i class="now-ui-icons ui-1_email-85"></i>
            </n-button>
          </el-tooltip>

          <!-- <el-tooltip placement="top">
            <div slot="content">前往訂單列表</div>
            <n-button type="primary" size="sm" icon @click.native="goToOrderList(scope.row)">
              <font-awesome-icon icon="receipt" />
            </n-button>
          </el-tooltip> -->
        </template>
      </el-table-column>
    </data-tables>
  </div>
</template>

<script>
import { Table, TableColumn, Select } from "element-ui";
import { fetchShops, fetchSiAccounts } from "./fetchData";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faQrcode);

import { DataTables, DataTablesServer } from "vue-data-tables";
import axios from "axios";
import moment from "moment";

// function fetchData() {
//   var config = {
//       method: "get",
//       url: "http://localhost:7654/line/system/businesses/all"
//   };
//   return axios(config);
// }
export default {
  components: {
    // [Table.name]: Table,
    // [TableColumn.name]: TableColumn,
    "font-awesome-icon": FontAwesomeIcon,
    DataTables,
    DataTablesServer,
    [Select.name]: Select
  },
  beforeRouteEnter(to, from, next) {
    fetchShops()
      .then(res => {
        console.log("res: ", res);
        next(vm => vm.setData(res));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      tableData: [],
      filters: [
        {
          prop: ["id", "name", "invoice"],
          value: ""
        }
      ],
      titles: [
        // {
        //   prop: "id",
        //   label: "商店ID"
        // },
        // {
        //   prop: "name",
        //   label: "商店名稱"
        // },
        // {
        //   prop: "siAccountName",
        //   label: "所屬SI"
        // }
        // {
        //   prop: "info",
        //   label: "Info"
        // }
      ],
      siAccounts: [],
      tableProps: {
        defaultSort: {
          prop: "id",
          order: "descending"
        }
      }
    };
  },
  created: function() {
    // fetchSiAccounts()
    //   .then(res => {
    //     this.siAccounts = res.data;
    //     console.log("created res: ", this.siAccounts);
    //   })
    //   .catch(err => {
    //     console.log("err: ", err);
    //   });
  },
  methods: {
    setData: function(res) {
      this.tableData = res.data.map(d => {
        return {
          name: d.name,
          info: d.storeInfo,
          id: d.id,
          accountId: d.accountId,
          siAccountName: d.siAccountName,
          siAccountId: d.siAccountId,
          invoice: d.invoice
        };
      });
    },
    clickInfo: function(row) {
      this.$router.push({ path: `/retail/si/common/${row.id}/info`, query: { siAccountId: row.siAccountId } });
    },
    clickEdit: function(row) {
      this.$router.push({ path: `/retail/si/common/${row.id}/edit` });
    },
    clickDel: function() {
      console.log("del clicked!");
    },
    clickQR: function(row) {
      this.$router.push({ path: `/retail/si/common/${row.id}/qr` });
    },
    sendEmail: function(row) {
      this.$router.push({
        path: `/account-email?shop_id=${row.accountId}&shop_name=${row.name}`
      });
    },
    openingSetting: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      this.$router.push({
        path: `/opening?${qs}`
        // path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${row.name}`
      });
    },
    goToOrderList(row) {
      console.log(row);
      this.$router.push({ path: `/summary/orders?shopId=${row.accountId}` });
    },

    // createShop() {
    //   this.$router.push({ path: `/si-business/wizard` });
    // },
    selectChange(row) {
      console.log("row: ", row);
    }
  }
};
</script>